import * as React from 'react';
import {
  useQuery,
  useMutation,
  useIsFetching,
  useQueryClient,
} from 'react-query';
import useFetch from 'react-fetch-hook';
import { useIsFocused } from '@react-navigation/native';
import { handleResponse, isOkStatus } from '../utils/handleRestApiResponse';
import usePrevious from '../utils/usePrevious';
import * as GlobalVariables from '../config/GlobalVariableContext';

export const stripeSessionPOST = (
  Constants,
  { fail_url, product_id, success_url },
  handlers = {}
) =>
  fetch(`https://xjz0-jmv4-gghx.n7.xano.io/api:UQuTJ3vx/sessions`, {
    body: JSON.stringify({
      success_url: success_url,
      cancel_url: fail_url,
      line_items: [{ price: product_id, quantity: 1 }],
    }),
    headers: {
      Accept: 'application/json',
      Authorization: Constants['auth_header'],
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }).then(res => handleResponse(res, handlers));

export const useStripeSessionPOST = (
  initialArgs = {},
  { handlers = {} } = {}
) => {
  const queryClient = useQueryClient();
  const Constants = GlobalVariables.useValues();
  return useMutation(
    args => stripeSessionPOST(Constants, { ...initialArgs, ...args }, handlers),
    {
      onError: (err, variables, { previousValue }) => {
        if (previousValue) {
          return queryClient.setQueryData('session', previousValue);
        }
      },
      onSettled: () => {
        queryClient.invalidateQueries('session');
        queryClient.invalidateQueries('sessions');
      },
    }
  );
};

export const FetchStripeSessionPOST = ({
  children,
  onData = () => {},
  handlers = {},
  refetchInterval,
  fail_url,
  product_id,
  success_url,
}) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();
  const prevIsFocused = usePrevious(isFocused);

  const {
    isLoading: loading,
    data,
    error,
    mutate: refetch,
  } = useStripeSessionPOST(
    { fail_url, product_id, success_url },
    { refetchInterval, handlers: { onData, ...handlers } }
  );

  React.useEffect(() => {
    if (!prevIsFocused && isFocused) {
      refetch();
    }
  }, [isFocused, prevIsFocused]);

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  return children({ loading, data, error, refetchStripeSession: refetch });
};
